/**
 * 高度工具
 */
"use strict";
angular.module("getHeightModule", []).
directive("getHeight", ["$timeout", "globleParamsSet", function($timeout, globleParamsSet) {
    return {
        restrict: 'A',
        scope: {
            expanded: "="
        },
        link: function(scope, $elem, $attrs) {
            globleParamsSet.domObserver($elem[0], { childList: true, attributeOldValue: true, attributes: true, attributeFilter: ['style'] }, function(e) {
                var lisHeight = 0;
                var lis = $elem.children();
                lis.each(function(index) {
                    lisHeight += $(this).height();
                });
                scope.lisHeight = lisHeight;
                expand();
            });
            scope.$watch("expanded", function(newV, oldV) {
                expand();
            });
            /**
             * [expand description] 展开或收起
             * @return {[type]} [description]
             */
            function expand() {
                if (scope.expanded) {
                    $elem.css("height", scope.lisHeight);
                } else {
                    $elem.css("height", 0);
                }
            }
        }
    };
}]);